import _ from 'lodash';
import fecha from 'fecha';
import * as omniture from './omnitureTracker';
import { isBussinessUser } from './BizUtils';
import { FUNNEL_OMNITURE_KEY } from '../constants/TrainConstants';

const LOB_NAME = 'Domestic Rails';
const isB2b = isBussinessUser();

let funnelData = {};

const _trackEvent = (pageName, data, extraData) => {
  funnelData = JSON.parse(sessionStorage.getItem(FUNNEL_OMNITURE_KEY)) || funnelData;
  omniture.trackOmniture(pageName, {
    ...funnelData,
    ..._prepareTrackingData(data, extraData),
  });
};

const _prepareTrackingData = (data, extraData) => {
  let trackingData = data;
  if (_.isString(trackingData)) {
    trackingData = {
      [omniture.PROP_54]: data,
    };
  }
  else if (_.isBoolean(trackingData)) {
    trackingData = {
      isLoad: data,
      ...(extraData && { [omniture.PURCHASE_ID]: extraData.PURCHASE_ID, [omniture.PURCHASE_KEY]: extraData.PURCHASE_ID }),
    };
  }
  return trackingData;
};

export const setFunnelVars = (travelProps) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const departureDate = fecha.parse(travelProps.departureDate, 'YYYYMMDD');

  const timeDiff = departureDate - currentDate;
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

  funnelData = {
    ...funnelData,
    [omniture.VAR_AP]: diffDays,
    [omniture.VAR_LOB_KEY]: LOB_NAME + (isB2b ? '|corporate': ''),
    ...(isB2b && { [omniture.VAR_BUSINESS_KEY]: 'corporate' }),
    ...(travelProps.srcCity && travelProps.destCity && {[omniture.VAR_SRC_DEST]: `${travelProps.srcCity}-${travelProps.destCity}`}),
    [omniture.VAR_START_DATE]: fecha.format(departureDate, 'DD:MM:YYYY'),
  };
};

export const setFunnelVarsForUser = (userProps) => {
  const { name, email, mobileNumber } = userProps;
  funnelData = {
    ...funnelData,
    [omniture.VAR_LOB_KEY]: LOB_NAME + (isB2b ? '|corporate': ''),
    ...(isB2b && { [omniture.VAR_BUSINESS_KEY]: 'corporate' }),
    [omniture.VAR_USER_LOGIN_STATUS]: name,
  };
};

export const trackListingEvent = (data) => {
  _trackEvent('funnel:rails:listing', data);
};

export const trackListingLoad = () => {
  trackListingEvent(true);
};

export const trackVerifyUsernameEvent = (data) => {
  _trackEvent('funnel:rails:irctc_username', data);
};

export const trackVerifyUsernameLoad = () => {
  trackVerifyUsernameEvent(true);
};

export const trackUsernameVerifiedEvent = (data) => {
  _trackEvent('funnel:rails:irctc_password', data);
};

export const trackUsernameVerifiedLoad = () => {
  trackUsernameVerifiedEvent(true);
};

export const trackThankyouEvent = (data, extraData) => {
  _trackEvent(`funnel:rails:thank_you_${data.page}`, data.event, extraData);
};

export const trackThankyouLoad = (page, extraData) => {
  const data = { page, event: true };
  trackThankyouEvent(data, extraData);
};

export const trackTravellersEvent = (data) => {
  _trackEvent('funnel:rails:travellers', data);
};

export const trackTravellerBookNowError = (event) => {
  const data = {
    [omniture.PROP_61]: `rails_dweb_error_${event}`,
  }
  _trackEvent('funnel:rails:travellers', data);
}

export const trackTravellersLoad = () => {
  trackTravellersEvent(true);
};

export const trackPageLoad = (pageName) => {
  _trackEvent(pageName, true);
}

export const trackClickEvent = (pageName, id) => {
  _trackEvent(pageName, id);
}

export function trackEvar47Event(pageName, eventName) {
  updateEvar47Variable(eventName);
  _trackEvent(pageName, {
    ...funnelData
  });
}

export function trackEvar47EventAfterRemovigOlderEvent(pageName, eventName, eventPrefix) {
  const evar47Variable = funnelData?.[omniture.EVAR_47] || '';
  let newEvarVariable = evar47Variable;
  if(evar47Variable.includes(eventPrefix)) {
    newEvarVariable = evar47Variable.split('|').
                      filter((event) => {
                      return event.includes(eventPrefix) ? '' : event
                      }).
                      join('|');
    newEvarVariable += '|';
  }
  Object.assign(funnelData,{[omniture.EVAR_47]:newEvarVariable});
  sessionStorage.setItem(FUNNEL_OMNITURE_KEY, JSON.stringify(funnelData));
  trackEvar47Event(pageName, eventName);
}

export const updateEvar47Variable = (event) => {
  let evar47Variable = funnelData?.[omniture.EVAR_47] || '';
  const eventTag = `${event}|`;

  if(!evar47Variable.split('|').includes(event)){
    evar47Variable += eventTag;
    Object.assign(funnelData,{[omniture.EVAR_47]:evar47Variable});
    sessionStorage.setItem(FUNNEL_OMNITURE_KEY, JSON.stringify(funnelData));
  }
}
